<template lang="pug">
.edi-template
  .entity-content.pa-5
    v-row
      h2.primary--text {{$t('Script.executeScriptTemplate')}}
    v-row
      v-col(cols="6")
        v-select(
          :label="$t('Script.rootEntity')",
          :value="(value || {}).entity",
          :items="schema",
          item-text="name",
          item-value="name",
          @input="selectEntity",
        )
    code-editor(
      v-model="instance.body",
      language="razor"
    )
  </template>    
<script>

export default {
  props: ['value'],
  data: function () {
    return {
      initObject: {
        type: 'ExecuteScript',
        body: '',
        entity: '',
        isRazor: true
      },
      instance: {}
    }
  },
  computed: {
    schema() {
      return this.$store.state.schema.all;
    },
  },
  watch: {
    instance: {
      deep: true,
      handler(val) {
        this.$emit('input', val)
      },
    },
  },
  methods: {
    selectEntity(val) {
      const input = { ...this.initObject, ...this.value, entity: val };
      this.$emit('input', input);
    },
  },
  created() {
    this.instance = { ...this.initObject, ...this.value };
  },
}
</script>
    